import { Route } from 'react-router-dom'
import { URLS } from './constants'
import { PrivateRoute } from 'components/utils/PrivateRoute'
import JobsPage from './jobs/Jobs/Jobs'
import PartnersList from './partners/Partners/Partners'
import JobDetails from './jobs/Jobs/JobDetails/JobDetails'
import JobCategories from './jobs/JobCategories/JobCategories'
import JobCategoryDetails from './jobs/JobCategories/JobCategoryDetails/JobCategoryDetails'
import PartnerDetails from './partners/Partners/PartnersDetails/PartnerDetails'
import ManagersList from './partners/Managers/Managers'
import ManagerDetails from './partners/Managers/ManagerDetails/ManagerDetails'
import AssignmentDetails from './partners/Partners/Assignments/AssignmentDetails/AssignmentDetails'
import DelegatesList from './partners/Delegates/Delegates'
import DelegateDetails from './partners/Delegates/DelegateDetails/DelegateDetails'
import { Assignments } from './partners/Assignments'
import { LegalEntities } from './partners/LegalEntities'
import { LegalEntity } from './partners/LegalEntity'
import { Stores } from './partners/Stores'
import { Store } from './partners/Store'

export const useIamRoutes = IamPages => {
  return (
    <>
      <Route
        path={URLS.IAM_JOBS_MANAGEMENT}
        element={<PrivateRoute component={JobsPage} applicationPages={IamPages} />}
      />
      <Route
        path={URLS.IAM_JOBS_MANAGEMENT_DETAILS}
        element={<PrivateRoute component={JobDetails} applicationPages={IamPages} />}
      />
      <Route
        path={URLS.IAM_JOBS_CATEGORIES_LIST}
        element={<PrivateRoute component={JobCategories} applicationPages={IamPages} />}
      />
      <Route
        path={URLS.IAM_JOBS_CAT_MANAGEMENT_DETAILS}
        element={<PrivateRoute component={JobCategoryDetails} applicationPages={IamPages} />}
      />

      <Route
        path={URLS.IAM_PARTNERS_MANAGEMENT}
        element={<PrivateRoute component={PartnersList} applicationPages={IamPages} />}
      />
      <Route
        path={URLS.IAM_PARTNER_DETAILS}
        element={<PrivateRoute component={PartnerDetails} applicationPages={IamPages} />}
      />
      <Route
        path={URLS.IAM_MANAGERS}
        element={<PrivateRoute component={ManagersList} applicationPages={IamPages} />}
      />
      <Route
        path={URLS.IAM_MANAGER_DETAILS}
        element={<PrivateRoute component={ManagerDetails} applicationPages={IamPages} />}
      />
      <Route
        path={URLS.IAM_DELEGATES}
        element={<PrivateRoute component={DelegatesList} applicationPages={IamPages} />}
      />
      <Route
        path={URLS.IAM_DELEGATE_DETAILS}
        element={<PrivateRoute component={DelegateDetails} applicationPages={IamPages} />}
      />
      <Route
        path={URLS.IAM_ASSIGNMENT_DETAILS}
        element={<PrivateRoute component={AssignmentDetails} applicationPages={IamPages} />}
      />
      <Route
        path={URLS.IAM_ASSIGNMENTS}
        element={<PrivateRoute component={Assignments} applicationPages={IamPages} />}
      />
      <Route
        path={URLS.IAM_LEGAL_ENTITIES}
        element={<PrivateRoute component={LegalEntities} applicationPages={IamPages} />}
      />
      <Route
        path={URLS.IAM_LEGAL_ENTITY_DETAILS}
        element={<PrivateRoute component={LegalEntity} applicationPages={IamPages} />}
      />
      <Route
        path={URLS.IAM_STORES}
        element={<PrivateRoute component={Stores} applicationPages={IamPages} />}
      />
      <Route
        path={URLS.IAM_STORE_DETAILS}
        element={<PrivateRoute component={Store} applicationPages={IamPages} />}
      />
    </>
  )
}
